import React, { Component, Fragment } from 'react';
import { Column, cls } from '../../../packages/components';
import SearchConstants from '../SearchConstants';
import CardByElement from './CardByElement';
import 'src/containers/Search/components/styles/componentsSearch.scss';

const ListItemsRanking = ({
    onFocus = null,
    items = [],
    bookmark = [],
    contentPlay = {},
    changeRoute = null,
    playFullMedia = null,
    user = null,
    contentsearch = null,
}) => {
    return (
        <div className={cls('aff_main_component_search_main')} id="aaf_main_search_main_div">
            {items &&
                Array.isArray(items) &&
                items.map((item, idx) => {
                    const item_style = {
                        height: `${100 / SearchConstants.quantity}%`,
                    };
                    return (
                        <div
                            className={cls('aff_main_component_search_main_column')}
                            style={item_style}
                        >
                            <CardByElement
                                onFocus={onFocus}
                                item={item}
                                bookmark={bookmark}
                                contentPlay={contentPlay}
                                changeRoute={changeRoute}
                                playFullMedia={playFullMedia}
                                user={user}
                                contentsearch={contentsearch}
                            />
                        </div>
                    );
                })}
        </div>
    );
};

const TextNoFoundAPI = ({ text = 'No se pueden mostrar los contenidos, intenta más tarde.' }) => {
    return (
        <div className="aaf_main_search_container_text_not_found_api">
            <div className="aaf_main_search_text_not_found_api">{text}</div>
        </div>
    );
};

const ComponentsSearch = (props) => {
    const { showTextNoFoundAPI = false, textAPIError = '' } = props;
    return <span>{!showTextNoFoundAPI  ? <ListItemsRanking {...props} /> : <TextNoFoundAPI text = {textAPIError}/>}</span>;
};

export default ComponentsSearch;



// WEBPACK FOOTER //
// ./src/containers/Search/components/ComponentsSearch.jsx